import { useTranslation } from "react-i18next"

import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"

export const useBuildEcoModulationSorts = () => {
  const { t } = useTranslation("regulations")
  const { sorts, setSorts } = useHeaderControlsContext()

  return {
    sorts,
    setSorts,
    sortOptions: [
      { label: t("ecoModulations.sorts.name"), value: "name" },
      { label: t("ecoModulations.sorts.reference"), value: "brandReference" },
      { label: t("ecoModulations.sorts.color"), value: "color" },
      { label: t("ecoModulations.sorts.collection"), value: "collection" },
      {
        label: t("ecoModulations.sorts.bonusDurability"),
        value: "bonusDurability",
      },
      {
        label: t("ecoModulations.sorts.bonusEnvironmentalLabels"),
        value: "bonusEnvironmentalLabels",
      },
      {
        label: t("ecoModulations.sorts.bonusRecycledMaterials"),
        value: "bonusRecycledMaterials",
      },
      {
        label: t("ecoModulations.sorts.malusMetalloplasticFibers"),
        value: "malusMetalloplasticFibers",
      },
      {
        label: t("ecoModulations.sorts.malusEeeComponents"),
        value: "malusEeeComponents",
      },
    ],
  }
}
